module.exports = __webpack_public_path__ + "static/info-a1ff12130048ed3b1b090cbf5c79e667.png";